
import { Component, Mixins, Prop } from "vue-property-decorator";
import FragmentBox from "@/components/boxes/FragmentBox.vue";
import BaseList from "@/components/base/BaseList.vue";
import { IFragmentBox } from "@/interfaces/fragment-box.interface";
import FragmentBoxesBalanceMixin from "@/mixins/fragment-boxes-balance.mixin";

@Component({
  components: {
    FragmentBox,
    BaseList,
  },
})
export default class FragmentBoxList extends Mixins(FragmentBoxesBalanceMixin) {
  @Prop() value!: IFragmentBox[];
  @Prop({ default: 4 }) loadingCount!: number;
}
